export default __webpack_public_path__ + "static/media/az.e11c3b71.svg";